// @ts-nocheck
import React from 'react';
import { Badge } from '@/components/ui/badge';

const LABELS = {
  high: 'High',
  'medium-high': 'Medium-high',
  medium: 'Medium',
  low: 'Low',
};

// Tailwind classes per confidence level (works in light + dark).
const CLASSES = {
  high: 'bg-success/10 text-success border-success/30',
  'medium-high': 'bg-lime-100 text-lime-800 border-lime-200',
  medium: 'bg-warning/10 text-warning border-warning/30',
  low: 'bg-destructive/10 text-destructive border-destructive/30',
};

export default function ConfidenceBadge({ level }) {
  const key = LABELS[level] ? level : 'medium';
  return (
    <Badge variant="outline" className={CLASSES[key]}>
      {LABELS[key]}
    </Badge>
  );
}
